import React, { Suspense } from "react";
import { InfoMenu as CreditsModal } from "../infoMenu/InfoMenu";
import { AdministrationUtilities } from "../../administration/AdministrationHelper";

export class PdfDocuments extends React.Component {

    constructor(props) {
        super(props);

        const installationInd = AdministrationUtilities.getInstallationId();

        this.state = {
            CustomPdfDocuments: null,
            loaded: false
        };

        this.modalRef = React.createRef();

        // Tentativo di import dinamico con fallback
        import(`../../_custom-layout/${installationInd}/PdfDocuments.js`)
            .then(module => {
                this.setState({
                    CustomPdfDocuments: React.lazy(() => Promise.resolve({ default: module.default })),
                    loaded: true
                });
            })
            .catch(() => {
                // Nessun PdfDocuments custom → non mostrare nulla
                this.setState({
                    CustomPdfDocuments: null,
                    loaded: true
                });
            });
    }

    render() {
        const { CustomPdfDocuments, loaded } = this.state;

        if (!loaded) return null;

        return (
            <>
                {CustomPdfDocuments && (
                    <Suspense fallback={null}>
                        <CustomPdfDocuments
                            onOpenModal={(bodyName, title) => this.modalRef.current._open(bodyName, title)}
                        />
                    </Suspense>
                )}

                <CreditsModal
                    ref={this.modalRef}
                    contentsFolder="pdf_contents"
                />
            </>
        );
    }
}

